import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { categories, allComics } from '@/mocks/comics';

export default function About() {
  const [faqOpen, setFaqOpen] = useState<number | null>(null);

  const faqs = [
    {
      q: '妖精漫画网的漫画资源是否完全免费？',
      a: '是的，妖精漫画网所有漫画资源均为完全免费阅读。我们致力于为广大漫画爱好者提供免费、优质的漫画阅读服务，无需付费订阅即可畅享海量韩漫、日漫、国漫资源。',
    },
    {
      q: '网站上的漫画更新频率是怎样的？',
      a: '妖精漫画网坚持每日更新，热门连载漫画与官方同步更新。热门漫画通常每周更新2-3话，确保读者能够第一时间追更，不再忍受等待的煎熬。',
    },
    {
      q: '妖精漫画网支持手机阅读吗？',
      a: '当然支持！妖精漫画网采用响应式设计，完美适配手机、平板和电脑。移动端提供下拉式阅读体验，让您在手机上也能够畅快地阅读漫画。',
    },
    {
      q: '是否需要注册账号才能阅读漫画？',
      a: '不需要！妖精漫画网无需注册登录即可直接阅读所有漫画内容。我们相信好的阅读体验应该简单直接，不受任何门槛限制。',
    },
    {
      q: '妖精漫画网有哪些类型的漫画？',
      a: `妖精漫画网涵盖${categories.map((c) => c.name).join('、')}等丰富类型，总数超过${allComics.length * 750}部漫画资源。无论您喜欢韩漫、日漫还是国漫，都能在这里找到心仪的作品。`,
    },
    {
      q: '如果遇到阅读问题该如何反馈？',
      a: '如果您在阅读过程中遇到任何问题，欢迎通过邮箱 service@bjyongkun.cn 与我们联系。我们的客服团队会在24小时内处理您的反馈。',
    },
  ];

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />

      <main className="pt-16">
        {/* Breadcrumb */}
        <div className="bg-background-100/70 border-b border-background-200/60">
          <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-3">
            <nav aria-label="面包屑导航" className="flex items-center gap-2 text-sm">
              <Link to="/" className="text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">
                首页
              </Link>
              <i className="ri-arrow-right-s-line text-foreground-400 text-xs"></i>
              <span className="text-foreground-800 font-medium">关于我们</span>
            </nav>
          </div>
        </div>

        {/* Brand Introduction */}
        <section className="py-12 md:py-16 bg-background-50" aria-labelledby="about-heading">
          <div className="max-w-[900px] mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <h1 id="about-heading" className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
                关于妖精漫画网
              </h1>
              <p className="text-foreground-600 max-w-xl mx-auto leading-relaxed text-sm md:text-base">
                妖精漫画网成立于2020年，是国内领先的免费漫画在线阅读平台，致力于为广大漫画爱好者提供最优质的阅读体验。
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
              <div className="p-6 rounded-xl bg-background-100 border border-background-200/60 text-center">
                <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-full bg-accent-100">
                  <i className="ri-book-open-line text-2xl text-accent-600"></i>
                </div>
                <h3 className="text-lg font-heading font-bold text-foreground-900 mb-2">海量资源</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  收录超过 {allComics.length * 750} 部漫画作品，涵盖韩漫、日漫、国漫等丰富类型，热门完结连载一应俱全。
                </p>
              </div>

              <div className="p-6 rounded-xl bg-background-100 border border-background-200/60 text-center">
                <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-100">
                  <i className="ri-shield-check-line text-2xl text-primary-500"></i>
                </div>
                <h3 className="text-lg font-heading font-bold text-foreground-900 mb-2">完全免费</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  始终坚持免费阅读理念，无需付费、无需注册，打开即看。让每一位漫画爱好者都能畅享阅读乐趣。
                </p>
              </div>

              <div className="p-6 rounded-xl bg-background-100 border border-background-200/60 text-center">
                <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-full bg-accent-100">
                  <i className="ri-flashlight-line text-2xl text-accent-600"></i>
                </div>
                <h3 className="text-lg font-heading font-bold text-foreground-900 mb-2">极速更新</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  与官方同步更新，热门连载每周更新2-3话。下拉式阅读设计，追更体验超爽，让你永不落伍。
                </p>
              </div>
            </div>

            {/* Brand Story */}
            <div className="prose max-w-none bg-background-100/70 rounded-xl p-6 md:p-8 border border-background-200/60 mb-12">
              <h2 className="text-xl font-heading font-bold text-foreground-950 mb-4">品牌故事</h2>
              <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                妖精漫画网的创立源于创始团队对漫画的热爱。在2020年，几位漫画爱好者发现市面上优质漫画平台要么收费高昂，要么资源匮乏。于是他们决定打造一个真正以读者为中心的免费漫画平台——妖精漫画网应运而生。
              </p>
              <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                从最初只有几百部漫画的小站，到如今拥有超过{allComics.length * 750}部漫画资源的在线阅读平台，妖精漫画网始终坚持「免费、全面、更新快」的核心理念。我们与多家漫画平台建立了合作关系，确保读者能够在第一时间阅读到最新更新的漫画内容。
              </p>
              <p className="text-sm text-foreground-700 leading-relaxed">
                妖精漫画网不仅提供海量的漫画资源，更注重用户的阅读体验。下拉式阅读设计、高清画质支持、智能推荐算法——这一切都是为了给漫画爱好者带来最舒适的在线阅读体验。未来，妖精漫画网将继续扩展漫画资源库，优化平台功能，让更多人享受到免费漫画阅读的乐趣。
              </p>
            </div>

            {/* Reader Reviews */}
            <div className="mb-12">
              <h2 className="text-xl font-heading font-bold text-foreground-950 mb-6 text-center">读者评价</h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                {[
                  { name: '漫画狂热者', text: '用了妖精漫画网之后再也回不去了，资源太全了！韩漫日漫国漫随便看，更新还特别快，推荐给所有漫画爱好者。', rating: 5 },
                  { name: '深夜追更人', text: '下拉式阅读真的很爽，比翻页舒服多了。而且完全免费这点太良心了，终于不用为了看漫画每个月花好几十了。', rating: 5 },
                  { name: '二次元少女', text: '妖精漫画网的恋爱漫画分类太全了！推荐系统也很准，推送的都是我喜欢的类型。画质清晰，阅读流畅，满分好评！', rating: 5 },
                ].map((review, idx) => (
                  <div key={idx} className="p-5 rounded-xl bg-background-100 border border-background-200/60">
                    <div className="flex items-center gap-1 mb-3">
                      {Array.from({ length: review.rating }).map((_, i) => (
                        <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                      &ldquo;{review.text}&rdquo;
                    </p>
                    <span className="text-xs text-foreground-500 font-medium">{review.name}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Contact */}
            <div className="bg-background-100/70 rounded-xl p-6 md:p-8 border border-background-200/60 mb-12" id="contact">
              <h2 className="text-xl font-heading font-bold text-foreground-950 mb-4">联系我们</h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-full bg-accent-100">
                    <i className="ri-mail-line text-accent-600"></i>
                  </div>
                  <div>
                    <h4 className="text-sm font-medium text-foreground-900 mb-1">电子邮箱</h4>
                    <p className="text-sm text-foreground-600">service@bjyongkun.cn</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-full bg-accent-100">
                    <i className="ri-customer-service-line text-accent-600"></i>
                  </div>
                  <div>
                    <h4 className="text-sm font-medium text-foreground-900 mb-1">客服支持</h4>
                    <p className="text-sm text-foreground-600">24小时内回复，竭诚为您服务</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-full bg-accent-100">
                    <i className="ri-shield-check-line text-accent-600"></i>
                  </div>
                  <div>
                    <h4 className="text-sm font-medium text-foreground-900 mb-1">版权声明</h4>
                    <p className="text-sm text-foreground-600">本站漫画资源均来源于网络，仅供学习交流使用。如涉及版权问题，请及时联系我们处理。</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-full bg-accent-100">
                    <i className="ri-links-line text-accent-600"></i>
                  </div>
                  <div>
                    <h4 className="text-sm font-medium text-foreground-900 mb-1">商务合作</h4>
                    <p className="text-sm text-foreground-600">欢迎漫画平台、创作者洽谈合作，请通过邮箱联系我们。</p>
                  </div>
                </div>
              </div>
            </div>

            {/* FAQ */}
            <div>
              <h2 className="text-xl font-heading font-bold text-foreground-950 mb-6 text-center">常见问题</h2>
              <div className="max-w-2xl mx-auto space-y-3">
                {faqs.map((faq, idx) => (
                  <div
                    key={idx}
                    className="rounded-xl bg-background-100 border border-background-200/60 overflow-hidden"
                  >
                    <button
                      onClick={() => setFaqOpen(faqOpen === idx ? null : idx)}
                      className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                    >
                      <span className="text-sm font-medium text-foreground-900">{faq.q}</span>
                      <i
                        className={`ri-arrow-down-s-line text-foreground-400 transition-transform duration-200 ${
                          faqOpen === idx ? 'rotate-180' : ''
                        }`}
                      ></i>
                    </button>
                    {faqOpen === idx && (
                      <div className="px-5 pb-4">
                        <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}